import styled from 'styled-components'

const HOUR_HEIGHT = 60

export const GradeWrapper = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  max-height: 72vh;
  display: flex;
  flex-direction: column;
`

export const GradeHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 70px repeat(5, 1fr);
  background: #7b0b99;
  flex-shrink: 0;
`

export const GradeHeaderCell = styled.div`
  color: white;
  padding: 10px 4px;
  text-align: center;
  font-weight: 700;
  font-size: 12px;
  border-left: 1px solid rgba(255,255,255,0.2);

  &:first-child {
    border-left: none;
  }
`

export const GradeBody = styled.div`
  display: flex;
  flex: 1;
  overflow-y: auto;
`

export const GradeTimeColumn = styled.div`
  min-width: 70px;
  max-width: 70px;
  flex-shrink: 0;
`

export const GradeTimeSlot = styled.div`
  height: ${HOUR_HEIGHT}px;
  padding: 4px 4px;
  text-align: center;
  font-weight: 600;
  font-size: 11px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  background: #f9f9f9;
`

export const GradeDaysGrid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
`

export const GradeDayColumn = styled.div`
  position: relative;
  border-right: 1px solid #e0e0e0;
`

export const GradeHourLine = styled.div`
  height: ${HOUR_HEIGHT}px;
  border-bottom: 1px solid #e0e0e0;

  &:hover {
    background: #fafafa;
  }
`

export const BlocoHorario = styled.div<{ cor: string; topPx: number; heightPx: number }>`
  position: absolute;
  left: 3px;
  right: 3px;
  top: ${props => props.topPx}px;
  height: ${props => props.heightPx}px;
  background: ${props => props.cor};
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 11px;
  line-height: 1.3;
  color: #333;
  overflow: hidden;
  cursor: pointer;
  z-index: 2;
  border-left: 4px solid ${props => {
    const c = props.cor;
    return c.length > 7 ? c.slice(0, -1) + ', 0.8)' : c;
  }};
  transition: box-shadow 0.15s;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 3px 8px rgba(0,0,0,0.2);
    z-index: 3;
  }

  strong {
    font-size: 12px;
    display: block;
    font-weight: 600;
  }
`

export const CargaHorariaCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
`

export const CargaBar = styled.div<{ percentual: number }>`
  height: 8px;
  border-radius: 4px;
  background: #e0e0e0;
  margin-top: 8px;
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    height: 100%;
    width: ${props => Math.min(props.percentual, 100)}%;
    background: ${props => props.percentual > 90 ? '#f44336' : props.percentual > 70 ? '#ff9800' : '#4caf50'};
    border-radius: 4px;
  }
`

export const ModalClienteItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;

  &:hover {
    background: #fafafa;
  }
`
